module.exports = __webpack_public_path__ + "static/poster-a5d76a32c263291f901b4b2dcf99fba6.png";